import React from "react";
import FaqsContainer from "../../containers/faqs/index";

const FaqsPage = () => <FaqsContainer />;

export default FaqsPage;
